module.exports = __webpack_public_path__ + "img/dcdac82.jpg";